import {
  cssManager,
  customElement,
  DeesElement,
  html,
  css,
  property
} from '@design.estate/dees-element';
import { themeDefaultStyles } from '../../00theme.js';

@customElement('dees-button-exit')
export class DeesButtonExit extends DeesElement {
  // DEMO
  public static demo = () => html`
    <dees-button-exit></dees-button-exit>
  `;
  public static demoGroups = ['Button'];

  // INSTANCE
  @property({
    type: Number
  })
  accessor size: number = 24;

  @property({ type: String })
  accessor label = 'Close';

  @property({ type: Boolean, reflect: true })
  accessor disabled = false;

  public static styles = [
    themeDefaultStyles,
    cssManager.defaultStyles,
    css`
      :host { display: inline-flex; }
      button {
        position: relative;
        min-width: 24px;
        min-height: 24px;
        border: 1px solid transparent;
        border-radius: var(--dees-radius-full);
        background: var(--dees-color-fill-tertiary);
        color: var(--dees-color-text-secondary);
        cursor: pointer;
        transition: background var(--dees-transition-fast), color var(--dees-transition-fast);
      }
      button::before, button::after {
        content: '';
        position: absolute;
        top: calc(50% - 1px);
        left: calc(50% - 6px);
        width: 12px;
        height: 2px;
        border-radius: 1px;
        background: currentColor;
        transform: rotate(45deg);
      }
      button::after { transform: rotate(-45deg); }
      button:hover { background: var(--dees-color-hover); color: var(--dees-color-text-primary); }
      button:focus-visible { outline: 2px solid var(--dees-color-focus-ring); outline-offset: 2px; }
      button:disabled { opacity: .5; cursor: default; }
      @media (prefers-reduced-motion: reduce) { button { transition: none; } }
    `
  ]

  public render() {
    return html`<button type="button" aria-label=${this.label} ?disabled=${this.disabled}
      style="width:${this.size}px;height:${this.size}px"></button>`;
  }

  public focus(optionsArg?: FocusOptions): void {
    this.shadowRoot?.querySelector('button')?.focus(optionsArg);
  }

  public blur(): void { this.shadowRoot?.querySelector('button')?.blur(); }
}
